import React from "react";

import { DashboardCard2 } from "@/components/layout/DashboardCard2";

export function AptihealthTips(props) {
  const { aptiTips } = props;

  return (
    <DashboardCard2 rawChildren>
      <p className="fs-18 pb-1">
        <strong>{aptiTips.heading}</strong>
      </p>

      <p className="mb-2 fs-14">{aptiTips.sub_heading}</p>
      <p className="aptiTips-content fs-14">{aptiTips.content}</p>
    </DashboardCard2>
  );
}
